var map = {
	"./bg_error.png": 6743,
	"./error_logo.svg": 1829,
	"./logo-matthes-academy.png": 6172,
	"./logo-matthes-academy.svg": 9536,
	"./logo_vplayer.png": 5016,
	"./signet-matthes.png": 1788,
	"./signet-matthes.svg": 2856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;